/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// biome-ignore-all lint: auto-generated code
// deno-lint-ignore-file

import { createKyConfig } from './setup';

import ky, { type KyInstance, type Options as KyOptions } from 'ky';

let _http: KyInstance | null = null;

/**
 * Initialises the ky HTTP client using the configuration returned by
 * `createKyConfig()` from your setup file.
 *
 * Call this once at application startup — for example inside a React provider
 * or your app's entry point — before any API calls are made.
 *
 * Re-calling this function replaces the existing instance. ky instances are
 * immutable, so hook changes require re-initialisation.
 */
export function initKyHttp(): void {
  _http = ky.create(createKyConfig());
}

/**
 * Returns the initialised ky instance. Throws if called before `initKyHttp()`.
 *
 * This guard prevents accidental use of the client before it has been
 * configured with hooks (auth, error handling, etc.).
 */
export function getKyHttp(): KyInstance {
  if (!_http) {
    throw new Error(
      '[Swaggie] ky client is not initialised. ' +
        'Call initKyHttp() at application startup before making any API requests.',
    );
  }
  return _http;
}
export const v4apicredentialsClient = {
  /**
   * @param body
   * @param organizationId
   */
  v4ApiCredentialsCreateApiCredential(
    body: CreateApiCredentialDTO,
    organizationId: string,
    $config?: KyOptions,
  ): Promise<ApiCredentialDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<ApiCredentialDTO>();
  },

  /**
   * @param organizationId
   * @param apiCredentialId
   */
  v4ApiCredentialsDeleteApiCredential(
    organizationId: string,
    apiCredentialId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials/${encodeURIComponent(`${apiCredentialId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param apiCredentialId
   */
  v4ApiCredentialsGetApiCredential(
    organizationId: string,
    apiCredentialId: string,
    $config?: KyOptions,
  ): Promise<ApiCredentialDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials/${encodeURIComponent(`${apiCredentialId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<ApiCredentialDTO>();
  },

  /** @param organizationId */
  v4ApiCredentialsListApiCredentials(organizationId: string, $config?: KyOptions): Promise<ApiCredentialsDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<ApiCredentialsDTO>();
  },

  /**
   * @param body
   * @param organizationId
   * @param apiCredentialId
   */
  v4ApiCredentialsPatchApiCredential(
    body: PatchApiCredentialDTO,
    organizationId: string,
    apiCredentialId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/api-credentials/${encodeURIComponent(`${apiCredentialId}`)}`;

    return getKyHttp().patch(url, {
      json: body,
      ...$config,
    });
  },
};

export const v5billinginvoicesClient = {
  /**
   * @param organizationId
   * @param invoiceId
   */
  v5BillingInvoicesGetInvoice(
    organizationId: string,
    invoiceId: string,
    $config?: KyOptions,
  ): Promise<GetInvoiceResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/${encodeURIComponent(`${invoiceId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<GetInvoiceResponseV5>();
  },

  /** @param organizationId */
  v5BillingInvoicesGetInvoices(organizationId: string, $config?: KyOptions): Promise<GetInvoicesResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<GetInvoicesResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (productSlug, startingOn, endingBefore, groupKey)
   */
  v5BillingInvoicesGetLineItemsUsageSummary(
    organizationId: string,
    queryParams: { productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5 },
    $config?: KyOptions,
  ): Promise<LineItemsUsageSummaryResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/line-items-usage-summary`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          productSlug: queryParams?.productSlug,
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          groupKey: queryParams?.groupKey,
        }),
        ...$config,
      })
      .json<LineItemsUsageSummaryResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (productSlug, startingOn, endingBefore, groupKey)
   */
  v5BillingInvoicesGetLineItemsUsageTotals(
    organizationId: string,
    queryParams: { productSlug: ProductSlugV5; startingOn: string; endingBefore: string; groupKey: ChargeGroupKeyV5 },
    $config?: KyOptions,
  ): Promise<LineItemsUsageSummaryResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/invoices/line-items/usage-totals`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          productSlug: queryParams?.productSlug,
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          groupKey: queryParams?.groupKey,
        }),
        ...$config,
      })
      .json<LineItemsUsageSummaryResponseV5>();
  },
};

export const v5billingconsumptionClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, recentConsumptionStartingOn, recentConsumptionEndingBefore)
   */
  v5BillingConsumptionGetCreditsSummary(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      recentConsumptionStartingOn?: string | null;
      recentConsumptionEndingBefore?: string | null;
    },
    $config?: KyOptions,
  ): Promise<GetCreditsSummaryResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/credits-summary`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          recentConsumptionStartingOn: queryParams?.recentConsumptionStartingOn,
          recentConsumptionEndingBefore: queryParams?.recentConsumptionEndingBefore,
        }),
        ...$config,
      })
      .json<GetCreditsSummaryResponseV5>();
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, groupKey, units, valuesLimit)
   */
  v5BillingConsumptionGetProductUsageGroupBreakdown(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      groupKey: ChargeGroupKeyV5;
      units: string;
      valuesLimit: number;
    },
    $config?: KyOptions,
  ): Promise<ProductUsageGroupBreakdownResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-group-breakdown/${encodeURIComponent(`${productSlug}`)}`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
          groupKey: queryParams?.groupKey,
          units: queryParams?.units,
          valuesLimit: queryParams?.valuesLimit,
        }),
        ...$config,
      })
      .json<ProductUsageGroupBreakdownResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingConsumptionGetProductsBreakdown(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: KyOptions,
  ): Promise<GetProductsBreakdownResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products-breakdown`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
          maxProjectionsCount: queryParams?.maxProjectionsCount,
        }),
        ...$config,
      })
      .json<GetProductsBreakdownResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window)
   */
  v5BillingConsumptionGetProductsConsumptionStats(
    organizationId: string,
    queryParams: { startingOn: string; endingBefore: string; window: ConsumptionWindowV5 },
    $config?: KyOptions,
  ): Promise<GetProductsConsumptionStatsV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products-stats`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
        }),
        ...$config,
      })
      .json<GetProductsConsumptionStatsV5>();
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore)
   */
  v5BillingConsumptionSingleProductGetCreditSummaryByDimension(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: { startingOn: string; endingBefore: string },
    $config?: KyOptions,
  ): Promise<GetProductCreditsSummaryResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/products/${encodeURIComponent(`${productSlug}`)}/credits-summary`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
        }),
        ...$config,
      })
      .json<GetProductCreditsSummaryResponseV5>();
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingConsumptionSingleProductGetProductConsumptionBreakdown(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: KyOptions,
  ): Promise<GetSingleProductConsumptionBreakdownResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/single-product-breakdown/${encodeURIComponent(`${productSlug}`)}`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
          maxProjectionsCount: queryParams?.maxProjectionsCount,
        }),
        ...$config,
      })
      .json<GetSingleProductConsumptionBreakdownResponseV5>();
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window)
   */
  v5BillingConsumptionSingleProductGetProductUsageBreakdown(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      aggregationProfile?: ChargeAggregationProfileSlugV5 | null;
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
    },
    $config?: KyOptions,
  ): Promise<GetProductUsageBreakdownResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-breakdown/${encodeURIComponent(`${productSlug}`)}`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          aggregationProfile: queryParams?.aggregationProfile,
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
        }),
        ...$config,
      })
      .json<GetProductUsageBreakdownResponseV5>();
  },

  /**
   * @param organizationId
   * @param productSlug
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, groupKeys, aggregationProfiles, valuesLimit)
   */
  v5BillingConsumptionSingleProductGetProductUsageTopGroups(
    organizationId: string,
    productSlug: ProductSlugV5,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      groupKeys: ChargeGroupKeyV5[];
      aggregationProfiles?: ChargeAggregationProfileSlugV5[] | null;
      valuesLimit: number;
    },
    $config?: KyOptions,
  ): Promise<GetProductUsageTopGroupsResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/consumption/product-usage-top-groups/${encodeURIComponent(`${productSlug}`)}`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          groupKeys: queryParams?.groupKeys,
          aggregationProfiles: queryParams?.aggregationProfiles,
          valuesLimit: queryParams?.valuesLimit,
        }),
        ...$config,
      })
      .json<GetProductUsageTopGroupsResponseV5>();
  },
};

export const v5billingworkspacesClient = {
  /**
   * @param organizationId
   * @param queryParams (optional) - Grouped query parameters object (offset, limit, sortBy, sortDir)
   */
  v5BillingConsumptionGetWorkspaces(
    organizationId: string,
    queryParams?: {
      offset?: number | null;
      limit?: number | null;
      sortBy?: WorkspaceListSortByV5 | null;
      sortDir?: SortDirV5 | null;
    } | null,
    $config?: KyOptions,
  ): Promise<GetWorkspacesResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/workspaces`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          offset: queryParams?.offset,
          limit: queryParams?.limit,
          sortBy: queryParams?.sortBy,
          sortDir: queryParams?.sortDir,
        }),
        ...$config,
      })
      .json<GetWorkspacesResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams (optional) - Grouped query parameters object (offset, limit, sortBy, sortDir)
   */
  v5BillingConsumptionGetWorkspacesStats(
    organizationId: string,
    queryParams?: {
      offset?: number | null;
      limit?: number | null;
      sortBy?: WorkspaceSortByV5 | null;
      sortDir?: SortDirV5 | null;
    } | null,
    $config?: KyOptions,
  ): Promise<GetWorkspacesStatsResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/workspaces/credits/stats`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          offset: queryParams?.offset,
          limit: queryParams?.limit,
          sortBy: queryParams?.sortBy,
          sortDir: queryParams?.sortDir,
        }),
        ...$config,
      })
      .json<GetWorkspacesStatsResponseV5>();
  },
};

export const v5billingcreditsClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window, maxProjectionsCount)
   */
  v5BillingCreditsGetContractsUtilization(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
    },
    $config?: KyOptions,
  ): Promise<GetContractsUtilizationResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/contracts-utilization`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
          maxProjectionsCount: queryParams?.maxProjectionsCount,
        }),
        ...$config,
      })
      .json<GetContractsUtilizationResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, recentConsumptionStartingOn, recentConsumptionEndingBefore)
   */
  v5BillingCreditsGetStats(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      recentConsumptionStartingOn?: string | null;
      recentConsumptionEndingBefore?: string | null;
    },
    $config?: KyOptions,
  ): Promise<GetCreditsSummaryResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/stats`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          recentConsumptionStartingOn: queryParams?.recentConsumptionStartingOn,
          recentConsumptionEndingBefore: queryParams?.recentConsumptionEndingBefore,
        }),
        ...$config,
      })
      .json<GetCreditsSummaryResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, recentConsumptionStartingOn, recentConsumptionEndingBefore)
   */
  v5BillingCreditsGetStats1(
    organizationId: string,
    queryParams: {
      startingOn: string;
      endingBefore: string;
      recentConsumptionStartingOn?: string | null;
      recentConsumptionEndingBefore?: string | null;
    },
    $config?: KyOptions,
  ): Promise<GetCreditsSummaryResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/status`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          recentConsumptionStartingOn: queryParams?.recentConsumptionStartingOn,
          recentConsumptionEndingBefore: queryParams?.recentConsumptionEndingBefore,
        }),
        ...$config,
      })
      .json<GetCreditsSummaryResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window, maxProjectionsCount, groupFilter)
   */
  v5BillingCreditsGetTimeseries(
    organizationId: string,
    queryParams: {
      aggregationProfile: ChargeAggregationProfileSlugV5;
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      maxProjectionsCount?: number | null;
      groupFilter?: string[] | null;
    },
    $config?: KyOptions,
  ): Promise<CreditsTimeseriesResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/timeseries`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          aggregationProfile: queryParams?.aggregationProfile,
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
          maxProjectionsCount: queryParams?.maxProjectionsCount,
          groupFilter: queryParams?.groupFilter,
        }),
        ...$config,
      })
      .json<CreditsTimeseriesResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore)
   */
  v5BillingCreditsGetTotals(
    organizationId: string,
    queryParams: { aggregationProfile: ChargeAggregationProfileSlugV5; startingOn: string; endingBefore: string },
    $config?: KyOptions,
  ): Promise<GetCreditsTotalsResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/credits/totals`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          aggregationProfile: queryParams?.aggregationProfile,
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
        }),
        ...$config,
      })
      .json<GetCreditsTotalsResponseV5>();
  },
};

export const v5billingproductsClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (startingOn, endingBefore, window)
   */
  v5BillingProductsGetStats(
    organizationId: string,
    queryParams: { startingOn: string; endingBefore: string; window: ConsumptionWindowV5 },
    $config?: KyOptions,
  ): Promise<GetProductsConsumptionStatsV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/products/stats`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
        }),
        ...$config,
      })
      .json<GetProductsConsumptionStatsV5>();
  },
};

export const v5billingpricesClient = {
  /** @param organizationId */
  v5BillingPricesGetPrices(organizationId: string, $config?: KyOptions): Promise<PriceListResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/prices`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<PriceListResponseV5>();
  },
};

export const v5billingusageClient = {
  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, window, groupValuesLimit)
   */
  v5BillingUsageGetTimeseries(
    organizationId: string,
    queryParams: {
      aggregationProfile: ChargeAggregationProfileSlugV5;
      startingOn: string;
      endingBefore: string;
      window: ConsumptionWindowV5;
      groupValuesLimit?: number | null;
    },
    $config?: KyOptions,
  ): Promise<UsageTimeseriesResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/usage/timeseries`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          aggregationProfile: queryParams?.aggregationProfile,
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          window: queryParams?.window,
          groupValuesLimit: queryParams?.groupValuesLimit,
        }),
        ...$config,
      })
      .json<UsageTimeseriesResponseV5>();
  },

  /**
   * @param organizationId
   * @param queryParams - Grouped query parameters object (aggregationProfile, startingOn, endingBefore, groupValuesLimit)
   */
  v5BillingUsageGetUsageTotals(
    organizationId: string,
    queryParams: {
      aggregationProfile: ChargeAggregationProfileSlugV5;
      startingOn: string;
      endingBefore: string;
      groupValuesLimit?: number | null;
    },
    $config?: KyOptions,
  ): Promise<GetUsageTotalsResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/usage/totals`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          aggregationProfile: queryParams?.aggregationProfile,
          startingOn: queryParams?.startingOn,
          endingBefore: queryParams?.endingBefore,
          groupValuesLimit: queryParams?.groupValuesLimit,
        }),
        ...$config,
      })
      .json<GetUsageTotalsResponseV5>();
  },
};

export const v5billingsearchsubscriptionClient = {
  /** @param organizationId */
  v5BillingSearchSubscriptionGetSearchSubscription(
    organizationId: string,
    $config?: KyOptions,
  ): Promise<SearchSubscriptionResponseV5> {
    const url = `v5/organizations/${encodeURIComponent(`${organizationId}`)}/billing/search-subscription`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<SearchSubscriptionResponseV5>();
  },
};

export const v1iamClient = {
  /** @param body */
  v1IamCheckPermission(body: CheckPermissionRequestDTO, $config?: KyOptions): Promise<CheckPermissionResponseDTO> {
    const url = `v1/authz/permissions/check`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<CheckPermissionResponseDTO>();
  },
};

export const v1notificationsClient = {
  /** @param jobId - Job ID to archive */
  notificationsArchiveJob(jobId: string, $config?: KyOptions): Promise<unknown> {
    const url = `v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}/archive`;

    return getKyHttp().patch(url, {
      ...$config,
    });
  },

  /** @param jobId */
  notificationsCancelScheduledJob(jobId: string, $config?: KyOptions): Promise<unknown> {
    const url = `v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}/cancel`;

    return getKyHttp().post(url, {
      ...$config,
    });
  },

  /** @param jobId */
  notificationsDeleteJob(jobId: string, $config?: KyOptions): Promise<unknown> {
    const url = `v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /** @param jobId - Job ID to execute */
  notificationsExecuteJob(jobId: string, $config?: KyOptions): Promise<ExecuteNotificationResponseDTO> {
    const url = `v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}/execute`;

    return getKyHttp()
      .post(url, {
        ...$config,
      })
      .json<ExecuteNotificationResponseDTO>();
  },

  notificationsGetBrands($config?: KyOptions): Promise<GetBrandsResponseDTO> {
    const url = `v1/notifications/brands`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<GetBrandsResponseDTO>();
  },

  /** @param templateId - Notification template id */
  notificationsGetCoordinatorTemplateVariables(
    templateId: string,
    $config?: KyOptions,
  ): Promise<GetCoordinatorTemplateVariablesResponseDTO> {
    const url = `v1/notifications/templates/${encodeURIComponent(`${templateId}`)}/coordinator-variables`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<GetCoordinatorTemplateVariablesResponseDTO>();
  },

  /** @param jobId */
  notificationsGetJob(jobId: string, $config?: KyOptions): Promise<NotificationJobResponseDTO> {
    const url = `v1/notifications/jobs/${encodeURIComponent(`${jobId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<NotificationJobResponseDTO>();
  },

  /** @param templateId - Notification template id */
  notificationsGetTemplate(templateId: string, $config?: KyOptions): Promise<TemplateContentResponseDTO> {
    const url = `v1/notifications/templates/${encodeURIComponent(`${templateId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<TemplateContentResponseDTO>();
  },

  notificationsGetTemplates($config?: KyOptions): Promise<GetTemplatesResponseDTO> {
    const url = `v1/notifications/templates`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<GetTemplatesResponseDTO>();
  },

  /** @param queryParams - Grouped query parameters object (limit, cursor, sortBy, sortOrder, name, status, templateId, channel, brandId, brandName, templateName, startDate, endDate, includeArchived) */
  notificationsListJobs(
    queryParams: {
      limit: number;
      cursor?: string | null;
      sortBy?: 'createdAt' | 'sendDate' | null;
      sortOrder?: 'asc' | 'desc' | null;
      name?: string | null;
      status?: string | null;
      templateId?: string | null;
      channel?: string | null;
      brandId?: string | null;
      brandName?: string | null;
      templateName?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      includeArchived?: boolean | null;
    },
    $config?: KyOptions,
  ): Promise<ListJobsResponseDTO> {
    const url = `v1/notifications/jobs`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          limit: queryParams?.limit,
          cursor: queryParams?.cursor,
          sortBy: queryParams?.sortBy,
          sortOrder: queryParams?.sortOrder,
          name: queryParams?.name,
          status: queryParams?.status,
          templateId: queryParams?.templateId,
          channel: queryParams?.channel,
          brandId: queryParams?.brandId,
          brandName: queryParams?.brandName,
          templateName: queryParams?.templateName,
          startDate: queryParams?.startDate,
          endDate: queryParams?.endDate,
          includeArchived: queryParams?.includeArchived,
        }),
        ...$config,
      })
      .json<ListJobsResponseDTO>();
  },

  /** @param body */
  notificationsScheduleNotification(
    body: ScheduleNotificationRequestDTO,
    $config?: KyOptions,
  ): Promise<ScheduleNotificationResponseDTO> {
    const url = `v1/notifications/schedule`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<ScheduleNotificationResponseDTO>();
  },

  /** @param body */
  notificationsSendNotification(
    body: SendNotificationRequestDTO,
    $config?: KyOptions,
  ): Promise<SendNotificationResponseDTO> {
    const url = `v1/notifications/send`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<SendNotificationResponseDTO>();
  },
};

export const v4sandboxesClient = {
  /** @param courseId */
  v4SandboxesAssignSandboxWorkspaceToUser(
    courseId: string,
    $config?: KyOptions,
  ): Promise<AssignedSandboxAssignmentDTO> {
    const url = `v4/sandboxes/${encodeURIComponent(`${courseId}`)}`;

    return getKyHttp()
      .post(url, {
        ...$config,
      })
      .json<AssignedSandboxAssignmentDTO>();
  },

  v4SandboxesGetAssignments($config?: KyOptions): Promise<SandboxAssignmentDTO[]> {
    const url = `v4/sandboxes`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<SandboxAssignmentDTO[]>();
  },
};

export const v4webhookClient = {
  /**
   * @param body
   * @param organizationId
   * @param workspaceId
   * @param xRequestId (optional) (API name: x-request-id) - Correlation ID for tracing
   */
  webhookControllerReceiveEvent(
    body: WebhookEventDTO,
    organizationId: string,
    workspaceId: string,
    xRequestId?: string | null,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/events`;

    return getKyHttp().post(url, {
      json: body,
      headers: {
        'x-request-id': xRequestId ?? undefined,
      },
      ...$config,
    });
  },
};

export const v4workspacesClient = {
  /** @param organizationId */
  v4OrganizationsGetInsightsFreeSlots(organizationId: string, $config?: KyOptions): Promise<InsightsFreeSlotsDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/insights-free-slots`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<InsightsFreeSlotsDTO>();
  },

  /** @param queryParams - Grouped query parameters object (state, cursor) */
  v4OrganizationsListAllWorkspaces(
    queryParams: {
      state:
        | 'Account-Prov'
        | 'Account-Ready'
        | 'Terraform-Prov'
        | 'Pre-Prov'
        | 'Terraform-Pre-Prov-Success'
        | 'Terraform-Pre-Prov-Failed'
        | 'Post-Prov'
        | 'Tenant-Ready'
        | 'Tenant-Assigned'
        | 'Tenant-Unassigned'
        | 'Cleanup-Requested'
        | 'Cleanup-Started'
        | 'Cleanup-Completed'
        | 'Cleanup-Failed'
        | 'Account-Available'
        | 'Tenant-Failed'
        | 'Tenant-FailedDLQ'
        | 'Tenant-Banished'
        | 'Workspace-Requested'
        | 'Workspace-Provisioning'
        | 'Workspace-Provisioning-Failed'
        | 'Workspace-Provisioned'
        | 'Workspace-Active'
        | 'Workspace-Asleep'
        | 'Workspace-Asleep-Requested'
        | 'Workspace-Wake-Requested'
        | 'Workspace-Updated'
        | 'Workspace-Failed-Update'
        | 'Workspace-Cleanup-Requested'
        | 'Workspace-Cleanup-Started'
        | 'Workspace-Cleanup-Terraform-Completed'
        | 'Workspace-Cleanup-Terraform-Failed'
        | 'Workspace-Cleanup-Completed'
        | 'Workspace-Cleanup-Failed';
      cursor?: string | null;
    },
    $config?: KyOptions,
  ): Promise<OrganizationWorkspacesDTO> {
    const url = `v4/organizations/workspaces`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          state: queryParams?.state,
          cursor: queryParams?.cursor,
        }),
        ...$config,
      })
      .json<OrganizationWorkspacesDTO>();
  },

  /**
   * @param body
   * @param organizationId
   */
  v4WorkspacesCreateWorkspace(
    body: CreateWorkspaceDTO,
    organizationId: string,
    $config?: KyOptions,
  ): Promise<WorkspaceDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<WorkspaceDTO>();
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesDeleteWorkspace(organizationId: string, workspaceId: string, $config?: KyOptions): Promise<unknown> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesGetInsightsDataRetentionForService(
    organizationId: string,
    workspaceId: string,
    $config?: KyOptions,
  ): Promise<InsightsDataRetentionDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/insights-data-retention`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<InsightsDataRetentionDTO>();
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesGetStaticEgressRegions(
    organizationId: string,
    workspaceId: string,
    $config?: KyOptions,
  ): Promise<StaticEgressRegionsDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/static-egress-regions`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<StaticEgressRegionsDTO>();
  },

  /**
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesGetWorkspace(organizationId: string, workspaceId: string, $config?: KyOptions): Promise<WorkspaceDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<WorkspaceDTO>();
  },

  /** @param organizationId */
  v4WorkspacesListWorkspaces(organizationId: string, $config?: KyOptions): Promise<WorkspacesDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<WorkspacesDTO>();
  },

  /**
   * @param body
   * @param organizationId
   * @param workspaceId
   */
  v4WorkspacesPatchWorkspace(
    body: PatchWorkspaceDTO,
    organizationId: string,
    workspaceId: string,
    $config?: KyOptions,
  ): Promise<WorkspaceDTO> {
    const url = `v4/organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<WorkspaceDTO>();
  },
};

/**
 * Serializes a params object into a query string that is compatible with different REST APIs.
 * Implementation from: https://github.com/suhaotian/xior/blob/main/src/utils.ts
 * Kudos to @suhaotian for the original implementation
 */
function _encodeParams<T = any>(
  params: T,
  parentKey: string | null = null,
  options?: {
    allowDots?: boolean;
    serializeDate?: (value: Date) => string;
    arrayFormat?: 'indices' | 'repeat' | 'brackets';
  },
): string {
  if (params === undefined || params === null) return '';
  const encodedParams: string[] = [];
  const paramsIsArray = Array.isArray(params);
  const { arrayFormat, allowDots, serializeDate } = options || {};

  const getKey = (key: string) => {
    if (allowDots && !paramsIsArray) return `.${key}`;
    if (paramsIsArray) {
      if (arrayFormat === 'brackets') {
        return '[]';
      }
      if (arrayFormat === 'repeat') {
        return '';
      }
    }
    return `[${key}]`;
  };

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      let value = (params as any)[key];
      if (value !== undefined) {
        const encodedKey = parentKey ? `${parentKey}${getKey(key)}` : (key as string);

        // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
        if (!isNaN(value) && value instanceof Date) {
          value = serializeDate ? serializeDate(value) : value.toISOString();
        }
        if (typeof value === 'object') {
          // If the value is an object or array, recursively encode its contents
          const result = _encodeParams(value, encodedKey, options);
          if (result !== '') encodedParams.push(result);
        } else {
          // Otherwise, encode the key-value pair
          encodedParams.push(`${encodeURIComponent(encodedKey)}=${encodeURIComponent(value)}`);
        }
      }
    }
  }

  return encodedParams.join('&');
}

/** Serializes a params object into a query string. Options override the generated defaults (allowDots, arrayFormat). */
export function encodeParams<T = any>(
  params: T,
  parentKey: string | null = null,
  options?: {
    allowDots?: boolean;
    serializeDate?: (value: Date) => string;
    arrayFormat?: 'indices' | 'repeat' | 'brackets';
  },
): string {
  return _encodeParams(params, parentKey, {
    allowDots: true,
    arrayFormat: 'repeat',
    ...options,
  });
}
export type DefaultErrorDTO = {
  statusCode: number;
  message: string;
  /** Stable machine-readable error code */
  code?: string;
};

export type ProductRoleDTO = {
  workspaceId: string;
  product: 'edge' | 'search' | 'stream' | 'lake' | 'insights';
  role: 'product_admin' | 'product_editor' | 'product_reader' | 'product_user' | 'product_noaccess';
};

export type WorkspaceRoleDTO = {
  workspaceId: string;
  role: 'ws_owner' | 'ws_admin' | 'ws_user' | 'noaccess';
};

export type ApiCredentialDTO = {
  clientId: string;
  clientSecret?: string;
  name: string;
  description?: string;
  productRoles: ProductRoleDTO[];
  workspaceRoles: WorkspaceRoleDTO[];
  organizationId: string;
  createdBy: string;
  /** @format date-time */
  createdDate: string;
  lastUpdatedBy: string;
  /** @format date-time */
  lastUpdatedDate: string;
  clientAssignedName: string;
  role: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  enabled: boolean;
  system: boolean;
  ipAllowlist: string[];
};

export type ApiCredentialsDTO = {
  items: ApiCredentialDTO[];
  count: number;
};

export type CreateApiCredentialDTO = {
  clientAssignedName: string;
  description: string;
  enabled: boolean;
  role: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  productRoles?: ProductRoleDTO[];
  workspaceRoles?: WorkspaceRoleDTO[];
  /** Optional CIDR allowlist for this credential. */
  ipAllowlist?: string[];
};

export type PatchApiCredentialDTO = {
  clientAssignedName?: string;
  description?: string;
  role?: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  enabled?: boolean;
  productRoles?: ProductRoleDTO[];
  workspaceRoles?: WorkspaceRoleDTO[];
  /** Omit to leave unchanged; [] or JSON null clears the stored allowlist. */
  ipAllowlist?: string[];
};

export enum InvoiceStatusV5 {
  DRAFT = 'DRAFT',
  FINALIZED = 'FINALIZED',
  VOID = 'VOID',
}

export enum InvoiceProductSlugV5 {
  Stream = 'stream',
  Search = 'search',
  Edge = 'edge',
  Lake = 'lake',
  Lakehouse = 'lakehouse',
  LocalSearch = 'local-search',
  FederatedEngine = 'federated-engine',
  LakeByos = 'lake-byos',
  Guard = 'guard',
  Infrastructure = 'infrastructure',
  Insights = 'insights',
  Other = 'other',
}

export enum ChargeGroupKeyV5 {
  Workspace = 'workspace',
  Workergroup = 'workergroup',
  DeploymentId = 'deployment_id',
  ClusterId = 'cluster_id',
  CloudProvider = 'cloud_provider',
  CloudRegion = 'cloud_region',
  Dataset = 'dataset',
  RetentionDays = 'retention_days',
  StorageLocationId = 'storage_location_id',
  Other = 'other',
}

export type ChargeGroupV5 = {
  key: ChargeGroupKeyV5;
  value: string;
};

export type LineItemV5 = {
  name: string;
  quantity: number;
  units?: string;
  credits: number;
  groups: ChargeGroupV5[];
};

export type InvoiceProductV5 = {
  slug: InvoiceProductSlugV5;
  parentProductSlug?: string;
  name: string;
  totalCredits: number;
  lineItems: LineItemV5[];
};

export type InvoiceV5 = {
  id: string;
  /** @format date-time */
  fromDate: string;
  /** @format date-time */
  toDate: string;
  totalCredits: number;
  status: InvoiceStatusV5;
  products: InvoiceProductV5[];
};

export type GetInvoicesResponseV5 = {
  items: InvoiceV5[];
  count: number;
};

export enum ProductSlugV5 {
  Stream = 'stream',
  Search = 'search',
  Edge = 'edge',
  Lake = 'lake',
  Lakehouse = 'lakehouse',
  LocalSearch = 'local-search',
  FederatedEngine = 'federated-engine',
  LakeByos = 'lake-byos',
  Guard = 'guard',
  Infrastructure = 'infrastructure',
  Insights = 'insights',
  Other = 'other',
}

export type LineItemsUsageSummaryPerUnitV5 = {
  /** The unit of measurement */
  units?: string;
  /** The aggregated quantity for the unit */
  quantity: number;
};

export type LineItemsUsageSummaryItemV5 = {
  /** The name of the item */
  name: string;
  /** The value of the group key */
  groupValue: string;
  /** Array of aggregated quantities per unit */
  perUnit: LineItemsUsageSummaryPerUnitV5[];
};

export type LineItemsUsageSummaryResponseV5 = {
  /** Array of aggregated line item usage summaries */
  items: LineItemsUsageSummaryItemV5[];
};

export type GetInvoiceResponseV5 = {
  data: InvoiceV5;
};

export enum TrendDirectionV5 {
  Increasing = 'increasing',
  Decreasing = 'decreasing',
  Stable = 'stable',
}

export type TrendV5 = {
  direction: TrendDirectionV5;
  percentageChange?: number;
  extremeThresholdReached?: boolean;
};

export type CreditGrantSummaryV5 = {
  id: string;
  /** @format date-time */
  date: string;
  creditsAcquired: number;
  type: string;
};

export type ContractsSummaryV5 = {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate?: string;
};

export type CreditsSummaryV5 = {
  totalCreditsRemaining: number;
  totalCreditsUsed: number;
  totalCreditsAcquired: number;
  recentConsumption: number;
  recentConsumptionTrend?: TrendV5;
  averageConsumption: number;
  /** @format date-time */
  contractStartDate: string;
  /** @format date-time */
  contractEndDate?: string;
  grants: CreditGrantSummaryV5[];
  contracts?: ContractsSummaryV5[];
};

export type GetCreditsSummaryResponseV5 = {
  data: CreditsSummaryV5;
};

export enum ConsumptionWindowV5 {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
  Quarterly = 'quarterly',
}

export type ProductCreditsConsumptionItemV5 = {
  slug: string;
  credits: number;
};

export type ProductsBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  products: ProductCreditsConsumptionItemV5[];
};

export type ProjectedProductsBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type ProductsBreakdownProjectionsV5 = {
  data: ProjectedProductsBreakdownItemV5[];
};

export type GetProductsBreakdownResponseV5 = {
  items: ProductsBreakdownItemV5[];
  count: number;
  projections?: ProductsBreakdownProjectionsV5;
};

export type ProductUnitStatsV5 = {
  averageQuantity: number;
  recentQuantity: number;
  totalQuantity: number;
  totalCredits: number;
  recentCredits: number;
  averageCredits: number;
  units?: string;
  trend?: TrendV5;
};

export type SingleProductConsumptionStatsV5 = {
  slug: ProductSlugV5;
  totalCredits: number;
  perUnit: ProductUnitStatsV5[];
};

export type GetProductsConsumptionStatsV5 = {
  items: SingleProductConsumptionStatsV5[];
  count: number;
};

export type WorkspaceCreditsBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type WorkspaceConsumptionStatsV5 = {
  workspaceId: string;
  monthlyAverageCredits: number;
  trailingCredits: number;
  trailingCreditsBreakdown?: WorkspaceCreditsBreakdownItemV5[];
  trend?: TrendV5;
};

export type GetWorkspacesStatsResponseV5 = {
  items: WorkspaceConsumptionStatsV5[];
  total: number;
};

export enum WorkspaceSortByV5 {
  WorkspaceId = 'workspaceId',
  TrailingCredits = 'trailingCredits',
  TotalCredits = 'totalCredits',
}

export enum SortDirV5 {
  Asc = 'asc',
  Desc = 'desc',
}

export type WorkspaceListItemV5 = {
  workspaceId: string;
};

export type GetWorkspacesResponseV5 = {
  items: WorkspaceListItemV5[];
  total: number;
};

export enum WorkspaceListSortByV5 {
  WorkspaceId = 'workspaceId',
  TotalCredits = 'totalCredits',
}

export type ProductCreditsSummaryItemV5 = {
  /** Human friendly name of the dimension */
  dimension: string;
  /** Total credits consumed for the dimension. */
  credits: number;
};

export type GetProductCreditsSummaryResponseV5 = {
  items: ProductCreditsSummaryItemV5[];
  /** Total number of items. */
  count: number;
};

export type SingleProductConsumptionBreakdownPerUnitItemV5 = {
  quantity: number;
  credits: number;
  units?: string;
};

export type SingleProductConsumptionBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
  perUnit: SingleProductConsumptionBreakdownPerUnitItemV5[];
};

export type SingleProductConsumptionBreakdownProjectedItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type SingleProductConsumptionBreakdownProjectionsV5 = {
  data: SingleProductConsumptionBreakdownProjectedItemV5[];
};

export type GetSingleProductConsumptionBreakdownResponseV5 = {
  items: SingleProductConsumptionBreakdownItemV5[];
  count: number;
  projections?: SingleProductConsumptionBreakdownProjectionsV5;
};

export enum ChargeAggregationProfileSlugV5 {
  TopOtherTypes = 'top-other-types',
  StreamAllEnvironments = 'stream-all-environments',
  StreamWorkergroups = 'stream-workergroups',
  StreamPerWorkspaceUsage = 'stream-per-workspace-usage',
  EdgeDroppedBytesVsTotalIngest = 'edge-dropped-bytes-vs-total-ingest',
  EdgePerWorkspaceUsage = 'edge-per-workspace-usage',
  SearchPerWorkspaceUsage = 'search-per-workspace-usage',
  LakePerWorkspaceUsage = 'lake-per-workspace-usage',
  LakeUsage = 'lake-usage',
  LakeCredits = 'lake-credits',
  Lakehouse = 'lakehouse',
  LocalSearch = 'local-search',
  InfrastructurePerWorkspaceUsage = 'infrastructure-per-workspace-usage',
  StaticEgressInfrastructurePerWorkspaceUsage = 'static-egress-infrastructure-per-workspace-usage',
  StaticEgressTrafficPerWorkspaceUsage = 'static-egress-traffic-per-workspace-usage',
  GuardPerWorkspaceUsage = 'guard-per-workspace-usage',
  AllChargesByProduct = 'all-charges-by-product',
  AllChargesByWorkspace = 'all-charges-by-workspace',
  StreamAllCharges = 'stream-all-charges',
  SearchAllCharges = 'search-all-charges',
  EdgeAllCharges = 'edge-all-charges',
  LakeAllCharges = 'lake-all-charges',
  LakehouseAllCharges = 'lakehouse-all-charges',
  LocalSearchAllCharges = 'local-search-all-charges',
  FederatedEngineAllCharges = 'federated-engine-all-charges',
  LakeByosAllCharges = 'lake-byos-all-charges',
  GuardAllCharges = 'guard-all-charges',
  InfrastructureAllCharges = 'infrastructure-all-charges',
  InsightsAllCharges = 'insights-all-charges',
  OtherAllCharges = 'other-all-charges',
}

export type ProductUsageBreakdownItemValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Quantity for this dimension value */
  quantity: number;
  /** Units corresponding to the quantity (optional) */
  units?: string;
};

export type ProductUsageBreakdownItemV5 = {
  /**
   * Date of the usage measurement
   * @format date-time
   */
  date: string;
  /** Values corresponds to the requested profile dimensions */
  values: ProductUsageBreakdownItemValueV5[];
};

export type GetProductUsageBreakdownResponseV5 = {
  /** List of usage breakdown items */
  items: ProductUsageBreakdownItemV5[];
  /** Number of items */
  count: number;
};

export type ProductUsageTopGroupItemPerUnitValueV5 = {
  value: string;
  quantity: number;
  trend?: TrendV5;
};

export type ProductUsageTopGroupItemPerUnitV5 = {
  units?: string;
  values: ProductUsageTopGroupItemPerUnitValueV5[];
};

export type ProductUsageTopGroupItemV5 = {
  key: string;
  perUnit: ProductUsageTopGroupItemPerUnitV5[];
};

export type GetProductUsageTopGroupsResponseV5 = {
  items: ProductUsageTopGroupItemV5[];
  count: number;
};

export type ProductUsageGroupBreakdownItemValueV5 = {
  value: string;
  quantity: number;
};

export type ProductUsageGroupBreakdownItemV5 = {
  /** @format date-time */
  date: string;
  values: ProductUsageGroupBreakdownItemValueV5[];
};

export type ProductUsageGroupBreakdownResponseV5 = {
  items: ProductUsageGroupBreakdownItemV5[];
  count: number;
};

export type CreditsTimeseriesDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Credits for this dimension */
  credits: number;
};

export type CreditsTimeseriesItemV5 = {
  /** @format date-time */
  date: string;
  /** Total credits consumed */
  credits: number;
  dimensions: CreditsTimeseriesDimensionValueV5[];
};

export type CreditsTimeseriesProjectedItemV5 = {
  /** @format date-time */
  date: string;
  credits: number;
};

export type CreditsTimeseriesProjectionsV5 = {
  data: CreditsTimeseriesProjectedItemV5[];
};

export type CreditsTimeseriesResponseV5 = {
  items: CreditsTimeseriesItemV5[];
  count: number;
  projections?: CreditsTimeseriesProjectionsV5;
};

export type CreditsTotalsDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Total credits consumed in the given interval for this dimension */
  credits: number;
};

export type CreditsTotalsItemV5 = {
  /** Total credits consumed across all dimensions */
  credits: number;
  dimensions: CreditsTotalsDimensionValueV5[];
};

export type GetCreditsTotalsResponseV5 = {
  totals: CreditsTotalsItemV5;
};

export type ContractUtilizationItemV5 = {
  /** @format date-time */
  date: string;
  /** Credits consumed at this date */
  credits: number;
};

export type ContractUtilizationV5 = {
  /**
   * Contract start date
   * @format date-time
   */
  contractStartDate: string;
  /**
   * Contract end date
   * @format date-time
   */
  contractEndDate?: string;
  /** Utilization data points for this contract */
  items: ContractUtilizationItemV5[];
};

export type ContractsUtilizationProjectionsV5 = {
  /** Projected utilization data points */
  data: ContractUtilizationItemV5[];
};

export type ContractsUtilizationV5 = {
  /** Contracts utilization list */
  contracts: ContractUtilizationV5[];
  /** Optional utilization projections */
  projections?: ContractsUtilizationProjectionsV5;
};

export type GetContractsUtilizationResponseV5 = {
  data: ContractsUtilizationV5;
};

export type PriceV5 = {
  chargeSlug: string;
  displayName: string;
  pricingGroup: Record<string, string>;
  quantityUnit: string;
  rate: number;
};

export type PriceListResponseV5 = {
  prices: PriceV5[];
};

export type UsageTimeseriesGroupValueV5 = {
  /** Group value name (e.g. workspace name) */
  name: string;
  /** Usage quantity for this group */
  value: number;
};

export type UsageTimeseriesDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Total usage quantity for this dimension in the time window */
  value: number;
  /** Display units (e.g. "GB", "CPU Hours") */
  units?: string;
  /** Group-level breakdown within this dimension */
  groupValues?: UsageTimeseriesGroupValueV5[];
};

export type UsageTimeseriesItemV5 = {
  /** @format date-time */
  date: string;
  dimensions: UsageTimeseriesDimensionValueV5[];
};

export type UsageTimeseriesResponseV5 = {
  items: UsageTimeseriesItemV5[];
  count: number;
};

export type UsageTotalsGroupValueV5 = {
  /** Group value name (e.g. workspace name) */
  name: string;
  /** Usage quantity for this group */
  value: number;
  /** Trend analysis for the group */
  trend?: TrendV5;
};

export type UsageTotalsDimensionValueV5 = {
  /** Dimension name */
  dimension: string;
  /** Total usage quantity for this dimension in the interval */
  value: number;
  /** Display units (e.g. "GB", "CPU Hours") */
  units?: string;
  /** Trend analysis for the dimension (only for charge-based profiles) */
  trend?: TrendV5;
  /** Group-level breakdown within this dimension */
  groupValues?: UsageTotalsGroupValueV5[];
};

export type GetUsageTotalsResponseV5 = {
  /** Dimensional breakdown of usage, ordered by value (biggest first) */
  dimensions: UsageTotalsDimensionValueV5[];
};

export type SearchSubscriptionResponseV5 = {
  isEnabled: boolean;
  /** @format date-time */
  contractEnd?: string;
};

export type EgressTypeNATCapabilityV1 = {
  /** Whether the capability is enabled */
  enabled?: boolean;
  /** Whether new workspaces provision with NAT egress and compatible leader ingress by default */
  applyOnProvision?: boolean;
};

export type PrivateLinkCapabilityV1 = {
  /** Whether the capability is enabled */
  enabled?: boolean;
  /** Maximum number of private links allowed for the workspace */
  maxPrivateLinks?: number;
  /** Maximum number of additional regions the workspace may accept PrivateLink connections from, totalled across all worker groups and the leader */
  maxCrossRegions?: number;
};

export type StandardCapabilityV1 = {
  /** Whether the capability is enabled */
  enabled: boolean;
};

export type ApiCredentialsCapabilityV1 = {
  /** Maximum number of non-system API client credentials allowed for the organization */
  maxApiCredentials?: number;
};

export type ApiCredentialCidrCapabilityV1 = {
  /** Maximum number of CIDR ranges allowed on a single API credential */
  maxCidrRanges?: number;
};

export type WorkspaceProvisioningCapabilityV1 = {
  /** Whether the capability is enabled */
  enabled?: boolean;
  /** Maximum number of workspaces allowed for the organization */
  maxWorkspaces?: number;
  /** Maximum number of workspaces included without additional charge */
  maxFreeWorkspaces?: number;
};

export type AclLimitCapabilityV1 = {
  /** Maximum number of ACL rules allowed per workspace */
  maxAclRules?: number;
};

export type SystemInsightsPolicyCapabilityV1 = {
  /** Number of non-main workspaces allowed on the free 48-hour retention tier */
  maxNonMainFreeWorkspaces: number;
};

export type LicenseTierCapabilityV1 = {
  /** Organization license tier */
  tier: 'standard' | 'enterprise';
};

export type CapabilitiesV1 = {
  /** Egress type NAT capability */
  'cloud.network.egressTypeNAT'?: EgressTypeNATCapabilityV1;
  /** Private link capability */
  'cloud.network.privateLink'?: PrivateLinkCapabilityV1;
  /** SMTP configuration capability */
  'cloud.notifications.smtpConfig'?: StandardCapabilityV1;
  /** Teams capability */
  'cloud.iam.teams'?: StandardCapabilityV1;
  /** Fine-grained roles capability */
  'cloud.iam.fineGrainedRoles'?: StandardCapabilityV1;
  /** API credentials limit capability */
  'cloud.iam.apiCredentials'?: ApiCredentialsCapabilityV1;
  /** API credential CIDR limit capability */
  'cloud.iam.apiCredentialCidr'?: ApiCredentialCidrCapabilityV1;
  /** SSO capability */
  'cloud.iam.sso'?: StandardCapabilityV1;
  /** Workspace provisioning capability */
  'cloud.workspace.provisioning'?: WorkspaceProvisioningCapabilityV1;
  /** Audit logs capability */
  'cloud.iam.eventlogs'?: StandardCapabilityV1;
  /** Multi-region workspaces capability */
  'cloud.workspace.multiRegion'?: StandardCapabilityV1;
  /** Release channels capability */
  'cloud.workspace.releaseChannels'?: StandardCapabilityV1;
  /** System insights capability */
  'cloud.product.systemInsights'?: StandardCapabilityV1;
  /** Customer metrics capability */
  'cloud.product.customerMetrics'?: StandardCapabilityV1;
  /** Connected deployments capability */
  'cloud.workspace.connectedDeployments'?: StandardCapabilityV1;
  /** Search capability */
  'cloud.product.search'?: StandardCapabilityV1;
  /** StreamAI capability */
  'cloud.product.streamAI'?: StandardCapabilityV1;
  /** Advanced Lake features capability */
  'cloud.product.advancedLakeFeatures'?: StandardCapabilityV1;
  /** ACL limit capability */
  'cloud.network.aclLimit'?: AclLimitCapabilityV1;
  /** System insights free-quota capability */
  'cloud.product.systemInsightsPolicy'?: SystemInsightsPolicyCapabilityV1;
  /** Organization license tier capability */
  'cloud.organization.licenseTier'?: LicenseTierCapabilityV1;
};

export type LicenseTierV1 = {
  /** License tier identifier */
  tierId: string;
  /** Revision number of the tier capabilities */
  revision: number;
  /** Capabilities configuration for this tier */
  capabilities: CapabilitiesV1;
};

export type LicenseTiersV1 = {
  /** List of all available license tiers */
  items: LicenseTierV1[];
};

export type InitOrganizationEntitlementRequestV1 = {
  /** License tier identifier */
  tierId: string;
};

export type OrganizationEntitlementV1 = {
  /** License tier identifier */
  tierId: string;
  /** Revision number of the tier capabilities */
  tierRevision: number;
  /** Organization-level capability overrides */
  capabilities?: CapabilitiesV1;
  /**
   * Timestamp when entitlements were initialized
   * @format date-time
   */
  createdAt: string;
  /**
   * Timestamp when entitlements were last updated
   * @format date-time
   */
  updatedAt: string;
};

export type UpdateTierRequestV1 = {
  /** New license tier identifier */
  tierId: string;
  /** Optional user comment for changelog */
  userComment?: string;
  /** Strategy for handling existing capability overrides during tier upgrade: keep, drop, or fail (default) */
  capabilitiesOverrides?: 'keep' | 'drop' | 'fail';
};

export type OverrideCapabilitiesRequestV1 = {
  /** Organization-level capability overrides. Partial overrides are supported - only specified capabilities will override tier defaults. Empty object {} removes all overrides. Both organization-level and workspace-level capability keys are accepted here because organization overrides may provide workspace defaults. */
  capabilities: CapabilitiesV1;
  /** Optional user comment for audit trail */
  userComment?: string;
};

export type WorkspaceCapabilitiesV1 = {
  /** Egress type NAT capability */
  'cloud.network.egressTypeNAT'?: EgressTypeNATCapabilityV1;
  /** Private link capability */
  'cloud.network.privateLink'?: PrivateLinkCapabilityV1;
  /** SMTP configuration capability */
  'cloud.notifications.smtpConfig'?: StandardCapabilityV1;
  /** Release channels capability */
  'cloud.workspace.releaseChannels'?: StandardCapabilityV1;
  /** System insights capability */
  'cloud.product.systemInsights'?: StandardCapabilityV1;
  /** Customer metrics capability */
  'cloud.product.customerMetrics'?: StandardCapabilityV1;
  /** Connected deployments capability */
  'cloud.workspace.connectedDeployments'?: StandardCapabilityV1;
  /** Search capability */
  'cloud.product.search'?: StandardCapabilityV1;
  /** StreamAI capability */
  'cloud.product.streamAI'?: StandardCapabilityV1;
  /** Advanced Lake features capability */
  'cloud.product.advancedLakeFeatures'?: StandardCapabilityV1;
  /** ACL limit capability */
  'cloud.network.aclLimit'?: AclLimitCapabilityV1;
};

export type WorkspaceEntitlementV1 = {
  /** Workspace identifier */
  workspaceId: string;
  /** Workspace-level capability overrides */
  capabilities: WorkspaceCapabilitiesV1;
  /**
   * Timestamp when the workspace entitlement was created
   * @format date-time
   */
  createdAt: string;
  /**
   * Timestamp when entitlements were last updated
   * @format date-time
   */
  updatedAt: string;
  /** Revision of the item. Used for optimistic locking. */
  itemRevision: string;
};

export type OverrideWorkspaceCapabilitiesRequestV1 = {
  /** Workspace-level capability overrides. Partial overrides are supported - only specified capabilities will override org defaults. Empty object {} removes all overrides. Org-only capability keys are not accepted. */
  capabilities: WorkspaceCapabilitiesV1;
  /** Optional user comment for changelog */
  userComment?: string;
};

export type EntitlementChangeLogEntryV1 = {
  /** The organization ID that the change applies to */
  organizationId: string;
  /** The workspace ID that the change applies to (if overridden on workspace level) */
  workspaceId?: string;
  /** License tier identifier */
  tierId: string;
  /** Revision number of the tier capabilities */
  tierRevision: number;
  /** The old capabilities before the change */
  oldCapabilities?: CapabilitiesV1;
  /** The new capabilities after the change */
  newCapabilities?: CapabilitiesV1;
  /** The user (or other identity) who made the change */
  initiator: Record<string, unknown>;
  /** Human readable reason for the change */
  systemComment: string;
  /**
   * Timestamp when the change was made
   * @format date-time
   */
  createdAt: string;
};

export type ChangelogResponseV1 = {
  /** List of changelog entries */
  items: EntitlementChangeLogEntryV1[];
  /** Cursor token for fetching the next page of results. If not present, there are no more items. */
  nextCursor?: string;
};

export type CapabilityDefinitionFieldV1 = {
  /** Field name on the capability payload */
  name: string;
  /** Short human-readable field label */
  label: string;
  /** Field value kind */
  kind: 'boolean' | 'number' | 'string';
  /** Minimum allowed value for numeric fields */
  min?: number;
  /** Allowed values for string enum fields (widened from registry readonly tuples for JSON serialization) */
  enumValues?: string[];
};

export type CapabilityDefinitionV1 = {
  /** Capability identifier */
  capabilityId: string;
  /** Level at which the capability operates */
  level: 'organization' | 'workspace';
  /** Short human-readable name, e.g. "Private Link" */
  label: string;
  /** One-line human-readable description of what the capability gates */
  description: string;
  /** Whether the capability is a boolean toggle (may include quotas) or structured-only */
  valueKind: 'booleanToggle' | 'structured';
  /** Editable fields on the capability payload */
  fields: CapabilityDefinitionFieldV1[];
};

export type CapabilityDefinitionsResponseV1 = {
  /** All known capability definitions */
  items: CapabilityDefinitionV1[];
};

export type OrganizationCapabilitiesV1 = {
  /** Teams capability */
  'cloud.iam.teams'?: StandardCapabilityV1;
  /** Audit logs capability */
  'cloud.iam.eventlogs'?: StandardCapabilityV1;
  /** Fine-grained roles capability */
  'cloud.iam.fineGrainedRoles'?: StandardCapabilityV1;
  /** API credentials limit capability */
  'cloud.iam.apiCredentials'?: ApiCredentialsCapabilityV1;
  /** API credential CIDR limit capability */
  'cloud.iam.apiCredentialCidr'?: ApiCredentialCidrCapabilityV1;
  /** Workspace provisioning capability */
  'cloud.workspace.provisioning'?: WorkspaceProvisioningCapabilityV1;
  /** Multi-region workspaces capability */
  'cloud.workspace.multiRegion'?: StandardCapabilityV1;
  /** SSO capability */
  'cloud.iam.sso'?: StandardCapabilityV1;
  /** System insights free-quota capability */
  'cloud.product.systemInsightsPolicy'?: SystemInsightsPolicyCapabilityV1;
  /** Organization license tier capability */
  'cloud.organization.licenseTier'?: LicenseTierCapabilityV1;
};

export type OrganizationCapabilitiesResponseV1 = {
  /** Resolved organization capabilities (tier defaults merged with org overrides) */
  capabilities: OrganizationCapabilitiesV1;
  /** Current license tier identifier (e.g. standard, enterprise) */
  tierId: string;
};

export type WorkspaceCapabilitiesResponseV1 = {
  /** Resolved workspace capabilities (tier defaults merged with org and workspace overrides) */
  capabilities: WorkspaceCapabilitiesV1;
  /** Current license tier identifier (e.g. standard, enterprise) */
  tierId: string;
};

export type PermissionDTO = {
  action: 'create' | 'read' | 'update' | 'delete';
  resource:
    | 'billing'
    | 'clients'
    | 'connections'
    | 'invites'
    | 'members'
    | 'teams'
    | 'workspaces'
    | 'workergroups'
    | 'availability_operations'
    | 'destructive_operations'
    | 'operations'
    | 'operations_fleet'
    | 'organization'
    | 'organization-auth-settings'
    | 'rollout'
    | 'smtp-configs'
    | 'leader'
    | 'connected-deployments';
};

export type ParentObjectDTO = {
  id: string;
  type: 'system' | 'organization' | 'workspace' | 'edge' | 'lake' | 'search' | 'stream';
  parent?: ParentObjectDTO;
};

export type ObjectDTO = {
  id: string;
  type: 'system' | 'organization' | 'workspace' | 'edge' | 'lake' | 'search' | 'stream';
  parent?: ParentObjectDTO;
};

export type CheckPermissionRequestDTO = {
  permission: PermissionDTO;
  object: ObjectDTO;
};

export type CheckPermissionResponseDTO = {
  /** Whether the user has the requested permission */
  allowed: boolean;
};

export type TemplateDTO = {
  /** Unique identifier for the template */
  id: string;
  /** Title of the template */
  title: string;
  /** Template editor type (classic blocks/channels or elemental) */
  editorType: 'classic' | 'elemental';
  /**
   * ISO 8601 date string when the template was created
   * @format date-time
   */
  createdAt: string;
  /**
   * ISO 8601 date string when the template was last updated
   * @format date-time
   */
  updatedAt: string;
  /** Tag names applied to the template */
  tags?: string[];
};

export type GetTemplatesResponseDTO = {
  /** List of notification templates */
  items: TemplateDTO[];
};

export type CoordinatorTemplateVariableDTO = {
  /** Variable path as used in template content (e.g. promoCode or data.field) */
  name: string;
  /** Logical type for UI validation */
  type: string;
  /** Whether the coordinator must supply a value before send */
  required: boolean;
  /** Optional guidance shown to coordinators */
  helpText?: string;
};

export type GetCoordinatorTemplateVariablesResponseDTO = {
  /** Coordinator-editable template variables */
  items: CoordinatorTemplateVariableDTO[];
  /** Zeus-supplied template variables referenced in this template (not coordinator-editable) */
  systemItems: string[];
};

export type TemplateContentChannelDTO = {
  /** Channel identifier */
  id: string;
  /** Channel type (e.g. email, push, sms) */
  type?: string;
  /** Default content (subject/title) */
  content?: Record<string, unknown>;
  /** Per-locale content overrides */
  locales?: Record<string, unknown>;
  /** Checksum of this channel content */
  checksum?: string;
};

export type TemplateContentBlockDTO = {
  /** Block identifier */
  id: string;
  /** Block type */
  type: 'action' | 'divider' | 'image' | 'jsonnet' | 'list' | 'markdown' | 'quote' | 'template' | 'text';
  /** Block alias */
  alias?: string;
  /** Block context */
  context?: string;
  /** Block content (string or structured) */
  content?: Record<string, unknown>;
  /** Per-locale content overrides */
  locales?: Record<string, unknown>;
  /** Checksum of this block */
  checksum?: string;
};

export type TemplateContentResponseDTO = {
  /** Template editor type (classic blocks/channels or elemental) */
  editorType: 'classic' | 'elemental';
  /** Channels defined for this template */
  channels?: TemplateContentChannelDTO[];
  /** Content blocks defined for this template */
  blocks?: TemplateContentBlockDTO[];
  /** Elemental content version identifier */
  version?: string;
  /** Elemental content elements for Design Studio templates */
  elements?: Record<string, unknown>[];
  /** Checksum covering the full template content */
  checksum?: string;
};

export type BrandColorsDTO = {
  /** Primary brand color */
  primary?: string;
  /** Secondary brand color */
  secondary?: string;
  /** Tertiary brand color */
  tertiary?: string;
};

export type BrandSettingsDTO = {
  /** Brand color palette */
  colors?: BrandColorsDTO;
  /** Email header/footer settings */
  email?: Record<string, unknown>;
};

export type BrandSnippetDTO = {
  /** Snippet format (e.g. handlebars) */
  format: string;
  /** Snippet name */
  name: string;
  /** Snippet value */
  value: string;
};

export type BrandDTO = {
  /** Unique identifier for the brand */
  id: string;
  /** Brand name */
  name: string;
  /**
   * ISO 8601 date string when the brand was last published
   * @format date-time
   */
  published: string;
  /**
   * ISO 8601 date string when the brand was created
   * @format date-time
   */
  createdAt: string;
  /**
   * ISO 8601 date string when the brand was last updated
   * @format date-time
   */
  updatedAt: string;
  /** Brand version identifier */
  version: string;
  /** Brand settings */
  settings?: BrandSettingsDTO;
  /** Brand snippets */
  snippets?: BrandSnippetDTO[];
};

export type GetBrandsResponseDTO = {
  /** List of notification brands */
  items: BrandDTO[];
};

export type SendNotificationRequestDTO = {
  /** Human-readable name for this notification job */
  name: string;
  /** Notification template ID from the notification templates API */
  notificationTemplateId: string;
  /** Brand ID for the notification */
  brandId: string;
  /** Target for the notification */
  notificationTarget: 'allOrganizations' | 'selectedOrganizations';
  /** User type filter (required for allOrganizations target) */
  userType?: 'regular' | 'oemCrowdStrike';
  /** License type filter (required for allOrganizations target) */
  licenseType?: 'all' | 'enterprise' | 'standard';
  /** List of organization IDs to exclude from notification */
  excludedOrganizations?: string[];
  /** List of specific organization IDs to target (required for selectedOrganizations target) */
  selectedOrganizations?: string[];
  /** Release channel filter. Applies to both notificationTarget modes; when omitted, defaults to "all". Use "all" to reach every targeted organization regardless of release channel. */
  releaseChannelFilter?: 'all' | 'regular' | 'stable';
  /** Template variable inputs as key-value pairs. Each key must match a coordinator-visible variable name for this template (see GET .../templates/:templateId/coordinator-variables). */
  templateInputs?: Record<string, unknown>;
  /**
   * Notification channel (normal or slow release)
   * @default "normal"
   */
  channel?: 'normal' | 'slowRelease';
  /**
   * Scheduled send date (if not provided, sends immediately)
   * @format date-time
   */
  sendDate?: string;
  /**
   * Send type: live for real execution, dryRun for preview only
   * @default "live"
   */
  sendType?: 'live' | 'dryRun';
};

export type SendNotificationResponseDTO = {
  /** Internal notification job ID */
  jobId: string;
  /** Provider bulk job ID when known (empty in the HTTP response; use the job detail API after processing) */
  providerJobId: string;
  /** Recipient count when known (0 in the HTTP response; use the job detail API after processing) */
  usersCount: number;
};

export type ScheduleNotificationRequestDTO = {
  /** Human-readable name for this notification job */
  name: string;
  /** Notification template ID from the notification templates API */
  notificationTemplateId: string;
  /** Brand ID for the notification */
  brandId: string;
  /** Target for the notification */
  notificationTarget: 'allOrganizations' | 'selectedOrganizations';
  /** User type filter (required for allOrganizations target) */
  userType?: 'regular' | 'oemCrowdStrike';
  /** License type filter (required for allOrganizations target) */
  licenseType?: 'all' | 'enterprise' | 'standard';
  /** List of organization IDs to exclude from notification */
  excludedOrganizations?: string[];
  /** List of specific organization IDs to target (required for selectedOrganizations target) */
  selectedOrganizations?: string[];
  /** Release channel filter. Applies to both notificationTarget modes; when omitted, defaults to "all". Use "all" to reach every targeted organization regardless of release channel. */
  releaseChannelFilter?: 'all' | 'regular' | 'stable';
  /** Template variable inputs as key-value pairs. Each key must match a coordinator-visible variable name for this template (see GET .../templates/:templateId/coordinator-variables). */
  templateInputs?: Record<string, unknown>;
  /**
   * Notification channel (normal or slow release)
   * @default "normal"
   */
  channel?: 'normal' | 'slowRelease';
  /**
   * Scheduled send date (required for scheduling)
   * @format date-time
   */
  sendDate: string;
  /**
   * Send type: live for real execution, dryRun for preview only
   * @default "live"
   */
  sendType?: 'live' | 'dryRun';
};

export type ScheduleNotificationResponseDTO = {
  /** Internal notification job ID */
  jobId: string;
};

export type NotificationJobRequestDataDTO = {
  channel: 'normal' | 'slowRelease';
  notificationTarget: 'allOrganizations' | 'selectedOrganizations';
  organizationId?: string;
  userType?: 'regular' | 'oemCrowdStrike';
  licenseType?: 'all' | 'enterprise' | 'standard';
  excludedOrganizations?: string[];
  usersCount: number;
};

export type NotificationJobResponseDataDTO = {
  providerJobId?: string;
  completedAt?: string;
  error?: string;
  failedAt?: string;
};

export type NotificationJobUserDTO = {
  email: string;
  status: 'ADDED' | 'SENT' | 'FAILED';
  addedAt: string;
  organizationIds: string[];
};

export type NotificationJobResponseDTO = {
  jobId: string;
  name: string;
  /** Brand display name when stored on the job */
  brandName?: string;
  /** Template title when stored on the job */
  templateName?: string;
  providerJobId?: string;
  templateId: string;
  brandId: string;
  schedulingType: 'immediate' | 'scheduled';
  sendType: 'live' | 'dryRun';
  sendDate: string;
  status: 'CREATED' | 'QUEUED' | 'AWAITING_SCHEDULE' | 'COMPLETED' | 'FAILED' | 'ARCHIVED' | 'CANCELED';
  requestData: NotificationJobRequestDataDTO;
  responseData?: NotificationJobResponseDataDTO;
  usersCount: number;
  organizationsCount: number;
  /** Predicted user count for scheduled jobs before execution */
  predictedUsersCount?: number;
  /** List of users with send status */
  users: NotificationJobUserDTO[];
  /** Organization IDs targeted by this job */
  organizationIds: string[];
  createdBy?: string;
  createdAt: string;
  lastUpdated: string;
};

export type ListJobsResponseDTO = {
  items: NotificationJobResponseDTO[];
  /** Cursor for next page */
  cursor?: string;
  limit: number;
};

export type ExecuteNotificationResponseDTO = {
  /** Internal notification job ID */
  jobId: string;
  /** Provider bulk job ID */
  providerJobId: string;
  /** Number of users who received the notification */
  usersCount: number;
};

export type AssignedSandboxAssignmentDTO = {
  organizationId: string;
  workspaceId: string;
  state: 'ASSIGNED';
  userId: string;
  courseId: string;
  /** @format date-time */
  assignedAt: string;
  /** @format date-time */
  expiresAt: string;
};

export type SandboxAssignmentDTO = {
  organizationId: string;
  workspaceId: string;
  state: 'PROVISIONING' | 'AVAILABLE' | 'ASSIGNING' | 'ASSIGNED' | 'DELETING';
  userId?: string;
  courseId?: string;
  /** @format date-time */
  assignedAt?: string;
  /** @format date-time */
  expiresAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  ssoConnection?: string;
};

export type WebhookEventResourceDTO = {
  /** The action that occurred */
  action: 'created' | 'deleted' | 'sync' | 'updated';
  /** The resource kind that was affected */
  kind:
    | 'LambdaManager'
    | 'WorkerGroup'
    | 'FastSearch'
    | 'LocalSearch'
    | 'StreamAI'
    | 'CriblLakeBucket'
    | 'SearchLambda'
    | 'SearchFleet'
    | 'TenantExec'
    | 'Team'
    | 'TeamMembers'
    | 'WorkspaceLeaderPrivateLink';
  /** Identifier of the resource (e.g. the worker group name) */
  id?: string;
};

export type WebhookEventDTO = {
  /** Schema version used by consumers to ascertain content / behaviour */
  version: number;
  /**
   * ISO 8601 Zulu datetime when the event was created
   * @format date-time
   */
  timestamp: string;
  /** ID of the user that initiated the event */
  userId: string;
  /** Organization ID this event pertains to */
  organizationId: string;
  /** The workspace this event occurred within */
  workspace: string;
  /** The resource affected by this event */
  resource: WebhookEventResourceDTO;
  /** Event parameters; shape varies by resource kind */
  parameters?: Record<string, unknown>;
};

export type OrganizationWorkspaceDTO = {
  organizationId: string;
  workspaceId: string;
  insightsEnabled: boolean;
  isInternal: boolean;
  /** Per-provider, per-region network egress mode as stored for this workspace. Keyed by cloud provider (AWS, AZURE, GCP); each value maps a region name to its egress mode ("public" or "nat"). Absent when not configured, null when explicitly cleared. Returned verbatim. */
  egressTypeByRegion?: {
    AWS?: Record<string, 'public' | 'nat'>;
    AZURE?: Record<string, 'public' | 'nat'>;
    GCP?: Record<string, 'public' | 'nat'>;
  } | null;
};

export type OrganizationWorkspacesDTO = {
  items: OrganizationWorkspaceDTO[];
  count: number;
  nextCursor?: string;
};

export type WorkspaceDTO = {
  workspaceId: string;
  alias?: string;
  description?: string;
  tags?: string[];
  region:
    | 'us-west-2'
    | 'us-east-1'
    | 'eu-central-1'
    | 'eu-west-2'
    | 'ap-southeast-2'
    | 'ca-central-1'
    | 'us-east-2'
    | 'eu-central-2'
    | 'ap-southeast-1'
    | 'ap-northeast-1'
    | 'sa-east-1'
    | 'eu-west-1'
    | 'eu-west-3';
  /** @format date-time */
  lastUpdated: string;
  leaderFQDN: string;
  state:
    | 'Workspace-Requested'
    | 'Workspace-Provisioning'
    | 'Workspace-Provisioning-Failed'
    | 'Workspace-Provisioned'
    | 'Workspace-Active'
    | 'Workspace-Asleep'
    | 'Workspace-Asleep-Requested'
    | 'Workspace-Wake-Requested'
    | 'Workspace-Updated'
    | 'Workspace-Failed-Update'
    | 'Workspace-Cleanup-Requested'
    | 'Workspace-Cleanup-Started'
    | 'Workspace-Cleanup-Terraform-Completed'
    | 'Workspace-Cleanup-Terraform-Failed'
    | 'Workspace-Cleanup-Completed'
    | 'Workspace-Cleanup-Failed';
  releaseChannel: 'stable' | 'regular' | 'rapid' | 'internal';
};

export type WorkspacesDTO = {
  items: WorkspaceDTO[];
  count: number;
};

export type StaticEgressRegionDTO = {
  provider: 'AWS' | 'AZURE';
  regionCode: string;
  status: 'available' | 'provisioning' | 'failed' | 'not-deployed' | 'unavailable';
  ipAddresses: string[];
};

export type StaticEgressRegionsDTO = {
  items: StaticEgressRegionDTO[];
  /** Effective workspace-infra artifact version after component overrides */
  workspaceInfraVersion?: string;
  /** Whether the effective workspace-infra artifact supports Static Egress IP mutations */
  isWorkspaceInfraVersionCompatible: boolean;
};

/** Customer-visible release channel (stable, regular, or rapid). Pass null to revert to the default (regular) channel. Internal channels are assigned by admins via the admin workspace PATCH channelSubscription field. */
export enum ReleaseChannel {
  Stable = 'stable',
  Regular = 'regular',
  Rapid = 'rapid',
}

export type PatchWorkspaceDTO = {
  alias?: string;
  description?: string;
  tags?: string[];
  /** Customer-visible release channel (stable, regular, or rapid). Pass null to revert to the default (regular) channel. Internal channels are assigned by admins via the admin workspace PATCH channelSubscription field. */
  releaseChannel?: ReleaseChannel | null;
  /** Enable or disable Cribl Insights on this workspace. */
  insightsEnabled?: boolean;
  /** Intended Insights data retention in days, chosen at enablement. The leader TTL is reconciled to this value once provisioning completes. */
  insightsRetentionDays?: 2 | 7 | 30 | 90 | 365;
  /** Per-provider, per-region network egress mode. Keyed by cloud provider (AWS, AZURE, GCP); each value maps a region name to its egress mode ("public" or "nat"). Null clears per-region configuration so the flat egressType applies. When present, provided provider/region entries are merged into the stored map; omitted regions are left unchanged. */
  egressTypeByRegion?: {
    AWS?: Record<string, 'public' | 'nat'>;
    AZURE?: Record<string, 'public' | 'nat'>;
    GCP?: Record<string, 'public' | 'nat'>;
  } | null;
};

export type CreateWorkspaceDTO = {
  alias?: string;
  description?: string;
  tags?: string[];
  /** Customer-visible release channel (stable, regular, or rapid). Pass null to revert to the default (regular) channel. Internal channels are assigned by admins via the admin workspace PATCH channelSubscription field. */
  releaseChannel?: ReleaseChannel | null;
  /** Enable or disable Cribl Insights on this workspace. */
  insightsEnabled?: boolean;
  /** Intended Insights data retention in days, chosen at enablement. The leader TTL is reconciled to this value once provisioning completes. */
  insightsRetentionDays?: 2 | 7 | 30 | 90 | 365;
  workspaceId: string;
  /** The region for workspace provisioning. When omitted, the organization's region is used. */
  region?: string;
};

export type InsightsDataRetentionDTO = {
  days: number;
};

export type SetInsightsDataRetentionDTO = {
  /** Target Insights data retention in days. */
  days: 2 | 7 | 30 | 90 | 365;
};

export type InsightsDataRetentionChangeDTO = {
  /** Retention in days before the change. */
  previousDays: number;
  /** Retention in days after the change. */
  days: number;
};

export type InsightsDataRetentionStatusDTO = {
  /** Whether Insights is enabled on this workspace. */
  insightsEnabled: boolean;
  /** Retention in days persisted in workspace config, or null if unset. */
  configDays: Record<string, unknown> | null;
  /** Retention in days on the live leader TTL, or null when Insights is disabled. */
  liveDays: Record<string, unknown> | null;
  /** Whether configDays and liveDays agree, or null when Insights is disabled. */
  inSync: Record<string, unknown> | null;
};

export type InsightsFreeSlotsDTO = {
  /** Number of free (2-day) Insights slots already used by Non-Main workspaces in the org. */
  freeSlotsUsed: number;
  /** Maximum number of free Insights slots allowed per organization. */
  limit: number;
  /** Whether the org has reached its free Insights slot limit. */
  isFreeLimitReached: boolean;
};
